import Header from "./components/Header";
import ChartWrap from "./components/ChartWrap";
import PageHeader from "./components/Page/Header";
import PageFooter from "./components/Page/Footer";
import copy from "./content/copy";
import track from "./helpers/track";

track.pageLoad(copy.metadata.lang);

function App() {
  return (
    <div>
      <div className={process.env.REACT_APP_STYLE}>
        <PageHeader />
        <Header copy={copy.intro} />
        <ChartWrap />
        <PageFooter text={copy.footer} />
      </div>
    </div>
  );
}

export default App;
